import { Schema } from 'zod';
import {
  PrimitiveFieldDefinition,
  PrimitiveFieldDefinitionSchema
} from './primitive';
import { DateFieldDefinition, DateFieldDefinitionSchema } from './date';
import {
  RichTextFieldDefinition,
  RichTextFieldDefinitionSchema
} from './richtext';
import { AssetFieldDefinition, AssetFieldDefinitionSchema } from './asset';
import { EnumFieldDefinition, EnumFieldDefinitionSchema } from './enum';

import { ObjectFieldDefinitionSchema, ObjectFieldDefinition } from './object';
import { ArrayFieldDefinition, ArrayFieldDefinitionSchema } from './array';

/**
 * All the field definition types.
 * @typedef FieldDefinition
 */
export type FieldDefinition =
  | PrimitiveFieldDefinition
  | DateFieldDefinition
  | RichTextFieldDefinition
  | AssetFieldDefinition
  | ObjectFieldDefinition
  | ArrayFieldDefinition
  | EnumFieldDefinition;

export const FieldDefinitionSchema: Schema<FieldDefinition> =
  PrimitiveFieldDefinitionSchema.or(AssetFieldDefinitionSchema)
    .or(DateFieldDefinitionSchema)
    .or(RichTextFieldDefinitionSchema)
    .or(ArrayFieldDefinitionSchema)
    .or(ObjectFieldDefinitionSchema)
    .or(EnumFieldDefinitionSchema);
